import { firstDefined } from '@avantia/client-and-server-utilities';
import { createControlId, HpFluentInputTextAndStyle } from '@avantia/questionset-model';

import { Button, InputGroup } from 'react-bootstrap';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { FluentFormGroupWidget } from '../../widgets/fluentFormGroupWidget';
import { BasicTextInputControl } from '../common/basicTextInputControl';
import { createMouseEvent } from '../inputControl';
import { compileQuestion } from './utilities';

export interface HpTextInputControlProps extends HpInputControlProps {
  placeholder?: string;
}

export function TextInputControl({
  answerSource,
  data,
  disabled,
  errors,
  id,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  placeholder,
  question,
  questionText,
  type,
  ui,
  value
}: HpTextInputControlProps): JSX.Element {
  const errorText = errors[id];
  const hasError = !!errorText;
  const { width } = data.textAndStyle.fluent as HpFluentInputTextAndStyle;
  const isEditing = ui.isEditing;

  const editControl = (
    <InputGroup className="mb-3" style={{ display: 'inline' }}>
      <BasicTextInputControl
        className={`fluent-input ${isEditing ? '' : 'fluent-hidden'} ${hasError ? 'fluent-error' : ''}`}
        disabled={disabled}
        eventDetail={{ type: 'fluent-change', question }}
        id={createControlId({ questionId: id, key: 'input', options: { noPrefix: true } })}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={firstDefined(placeholder, questionText)}
        questionText={questionText}
        type={type}
        value={value}
        width={width}
      />
      <div className={`fluent-input ${isEditing ? '' : 'fluent-hidden'}`}>
        <Button
          id={createControlId({ questionId: id, key: 'ok' })}
          variant="success"
          disabled={hasError}
          onClick={createMouseEvent(onClick, { type: 'fluent-ok', question })}
        >
          OK
        </Button>
      </div>
    </InputGroup>
  );

  const control = compileQuestion({
    questionText,
    answerText: value as string,
    id: createControlId({ questionId: id }),
    onClick: createMouseEvent(onClick, { type: 'fluent-toggle', question }),
    editControl,
    className: `fluent-input ${isEditing ? 'fluent-hidden' : ''}`
  });

  return (
    <FluentFormGroupWidget
      answerSource={answerSource}
      controlType="text-input"
      error={errorText}
      id={id}
      question={control}
    />
  );
}
